import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <IndexSection />

        <UpdatesSection />

        <AppSection />

        <CardsSection />

        <TopicsSection />

        <FeaturesSection />

        <MediaSection />

        <CarouselSection />

        <ContactSection />

        <FaqSection />

        <AboutSection />

        <RankingSection />

        <CommentsSection />
      </main>

      <Footer />
    </div>
  );
}